import { useAccount, useMsal } from "@azure/msal-react";
import {
    Button, CircularProgress, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    Paper,
    TextField,
    Typography
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { validate, validateHelper, validationType } from "../../../features/validate/validate";
import { messstelle, schaltfeld, spannungswandler, stromwandler, umspannwerk } from "../../../utils/apiTypes";
import { isAuthorized, rollen } from "../../../utils/auth/authConfig";
import {
    createMessstelle, deleteMessstelle, discardChanges, discardNew, getSapnnungsebene, getSpannungswandler, getStromwandler, getUWs, recreateMessstelle, resetError, selectAktuelleMessstelle, selectAlteMessstelle, selectDublicatName, resetViewMode,
    selectEditDirty, selectEditEntry, selectError, selectListLoading, selectNewEntry, selectSchaltfelder, selectSchaltfeldLoading, selectSpannungsebene, selectSpannungsebeneLoading, selectSpannungswandler, selectSpannungswandlerLoading, selectStromwandler, selectStromwandlerLoading, selectUWKoordinatenUebernehmenDialog, selectUwLoading, selectUWs, selectViewMode, setBreitengrad, setEditEntry, setError, setKommentar, setKoordinatenFromUW, setLaengengrad, setName, setSchaltfeld, setSpannungsebene, setSpannungswandler, setStromwandler, setUWKoordinatenUebernehmenDialog, updateMessstelle, updateUmspannwerk
} from "./messstellenSlice";
import { useStyles } from "./messstellenStyles";


export default function MessstellenEdit(): ReactElement {

    const dispatch = useAppDispatch();
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const rollenObj = rollen;


    useEffect(() => {
        dispatch(getUWs());
        dispatch(getSapnnungsebene());
        dispatch(getStromwandler());
        dispatch(getSpannungswandler());
    }, [account, instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };
    const
        uwSelectList: umspannwerk[] = useAppSelector(selectUWs),
        schaltfeldSelectList: schaltfeld[] = useAppSelector(selectSchaltfelder),
        spannungsebeneSelectList: Array<string> = useAppSelector(
            selectSpannungsebene
        ),
        stromwandlerSelectList: Array<stromwandler> = useAppSelector(
            selectStromwandler
        ),
        spannungswandlerSelectList: Array<spannungswandler> = useAppSelector(selectSpannungswandler),
        editEntry: boolean = useAppSelector(selectEditEntry),
        newEntry: boolean = useAppSelector(selectNewEntry),
        dublicateName: boolean = useAppSelector(selectDublicatName),
        aktuelleMessstelle: messstelle = useAppSelector(selectAktuelleMessstelle),
        alteMessstelle: messstelle = useAppSelector(selectAlteMessstelle),
        viewMode: boolean = useAppSelector(selectViewMode),
        dirtyEdit: boolean = useAppSelector(selectEditDirty),
        inputError: boolean = useAppSelector(selectError),
        uwKoordinatenDialog: boolean = useAppSelector(selectUWKoordinatenUebernehmenDialog),
        listLoading: boolean = useAppSelector(selectListLoading),
        schaltfeldLoading: boolean = useAppSelector(selectSchaltfeldLoading),
        spannungsebeneLoading: boolean = useAppSelector(selectSpannungsebeneLoading),
        spannungswandlerLoading: boolean = useAppSelector(selectSpannungswandlerLoading),
        stromwandlerLoading: boolean = useAppSelector(selectStromwandlerLoading),
        uwLoading: boolean = useAppSelector(selectUwLoading);




    function printSaveDiscardButtons() {
        return (
            <div>

                <Button
                    variant="contained"
                    onClick={() => {
                        newEntry
                            ? dispatch(createMessstelle(aktuelleMessstelle))
                            : aktuelleMessstelle.jemalsZugeordnet
                                ? dispatch(updateMessstelle(aktuelleMessstelle))
                                : dispatch(
                                    recreateMessstelle(aktuelleMessstelle, alteMessstelle)
                                );
                    }}
                    color="secondary"
                    className={classes.showtriButton}
                    disabled={
                        aktuelleMessstelle.schaltfeld == "" ||
                        aktuelleMessstelle.name == "" ||
                        aktuelleMessstelle.spannungsebene == "" ||
                        aktuelleMessstelle.stromwandler == "" ||
                        aktuelleMessstelle.spannungswandler == "" ||
                        dublicateName ||
                        !dirtyEdit ||
                        inputError
                    }
                    style={{ minHeight: "36px" }}
                >
                    {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        newEntry ? dispatch(discardNew()) : dispatch(discardChanges());
                    }}
                    color="secondary"
                    className={classes.showtriButton}
                >
                    Abbrechen
                </Button>
            </div>
        );
    }

    function confirmDeleteOfMessstelle() {
        dispatch(deleteMessstelle(aktuelleMessstelle));
        setOpenDeleteDialog(false);
    }

    function printEditDeleteButton() {
        if (isAuthorized([rollenObj.admin, rollenObj.betrieb]))
            return (
                <div>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(setEditEntry())}
                        color="secondary"
                        className={classes.showtriButton}
                    >
                        Bearbeiten
                    </Button>
                    {!aktuelleMessstelle.jemalsZugeordnet ?
                    <Button
                        variant="contained"
                        onClick={() => setOpenDeleteDialog(true)}
                        color="secondary"
                        className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
                    >
                        Löschen
                    </Button> : ""}
                    <Dialog
                        open={openDeleteDialog}
                        onClose={() => setOpenDeleteDialog(false)}
                    >
                        <DialogTitle>Messstelle löschen</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {'Sind Sie sicher, dass Sie die Messstelle "' +
                                    aktuelleMessstelle.name +
                                    '" wirklich löschen wollen?'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => setOpenDeleteDialog(false)}
                                className={classes.cancleDeleteButton}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                variant="contained"
                                onClick={confirmDeleteOfMessstelle}
                                className={classes.confirmDeleteButton}
                                style={{ minWidth: "120px", minHeight: "36px" }}
                            >
                                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Button
                        variant="contained"
                        onClick={() => { dispatch(resetViewMode())}}
                        color="default"
                        className={classes.showtriButton}
                    >
                        Schließen
                    </Button>
                </div>
            );
        else return (<React.Fragment />)
    }


    function printUWKoordinatenDialog() {
        return (
            <Dialog
                open={uwKoordinatenDialog}
                onClose={() => dispatch(setUWKoordinatenUebernehmenDialog(false))}
            >
                <DialogTitle>Koordinaten übernehmen</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {'Möchten Sie die für das Umspannwerk hinterlegten Koordinaten übernehmen?'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => dispatch(setUWKoordinatenUebernehmenDialog(false))}
                        className={classes.cancleDeleteButton}
                    >
                        Nein
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(setKoordinatenFromUW())}
                        color="secondary"
                    >
                        Ja, übernehmen
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    const [uwSelectInputValue, setUwSelectInputValue] = React.useState("");
    const [
        schaltfeldSelectInputValue,
        setSchaltfeldSelectInputValue,
    ] = React.useState("");
    const [
        spannungsebeneSelectInputValue,
        setSpannungsebeneSelectInputValue,
    ] = React.useState("");
    const [
        stromwandlerSelectInputValue,
        setStromwandlerSelectInputValue,
    ] = React.useState("");
    const [
        spannungswandlerSelectInputValue,
        setSpannungswandlerSelectInputValue,
    ] = React.useState("");

    if (viewMode) {
        return (
            <React.Fragment>
                <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
                    <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
                        <div>
                            <Grid container>
                                <Grid container spacing={4}>
                                    <Grid item container xs={12}>
                                    <Grid item md={3}>
                                        <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"}>
                                            {newEntry
                                                ? "Neue Messstelle anlegen"
                                                : "Bearbeiten von Messstelle: " +
                                                aktuelleMessstelle.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item md={3} />
                                    <Grid item md={6}>
                                        {editEntry
                                            ? printSaveDiscardButtons()
                                            : printEditDeleteButton()}
                                    </Grid>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl className={classes.fullWidth}>
                                            <TextField
                                                required={true}
                                                disabled={
                                                    newEntry ||
                                                        (!aktuelleMessstelle.jemalsZugeordnet && editEntry)
                                                        ? false
                                                        : true
                                                }
                                                id="messstelle-name"
                                                helperText={
                                                    validateHelper(aktuelleMessstelle.name, validationType.name) + (
                                                        dublicateName && newEntry
                                                            ? "Name muss eindeutig sein"
                                                            : aktuelleMessstelle.jemalsZugeordnet &&
                                                                editEntry &&
                                                                !newEntry
                                                                ? "Name kann nur bei nicht verwendeten Messstellen geändert werden"
                                                                : "")
                                                }
                                                error={(dublicateName && newEntry) || validate(dispatch, setError, resetError, aktuelleMessstelle.name, "name", validationType.name)}
                                                inputProps={{ maxLength: 50 }}
                                                label="ID"
                                                variant="outlined"
                                                onChange={(event) =>
                                                    dispatch(setName(event.target.value))
                                                }
                                                value={aktuelleMessstelle.name}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="select-messstellen-uw"
                                            disabled={editEntry ? false : true}
                                            value={aktuelleMessstelle.umspannwerk}
                                            noOptionsText={<React.Fragment>
                                                {uwLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Umspannwerke"}</React.Fragment>}
                                            onChange={(event, newValue) => {
                                                if (newValue) dispatch(updateUmspannwerk(newValue));
                                            }}
                                            inputValue={uwSelectInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setUwSelectInputValue(newInputValue);
                                            }}
                                            options={uwSelectList.map((x) => x.name)}
                                            getOptionLabel={(option) => (option ? option : "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    required={true}
                                                    {...params}
                                                    label="Umspannwerk"
                                                    variant="outlined"
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl className={classes.fullWidth}>
                                            <TextField
                                                id="messstelle-laengengrad"
                                                disabled={editEntry ? false : true}
                                                type="number"
                                                className={classes.numberField}
                                                label="Längengrad"
                                                variant="outlined"
                                                onChange={(event) =>
                                                    dispatch(setLaengengrad(Number(event.target.value)))
                                                }
                                                value={aktuelleMessstelle.laengengrad}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl className={classes.fullWidth}>
                                            <TextField
                                                id="messstelle-breitengrad"
                                                type="number"
                                                disabled={editEntry ? false : true}
                                                className={classes.numberField}
                                                label="Breitengrad"
                                                variant="outlined"
                                                onChange={(event) =>
                                                    dispatch(setBreitengrad(Number(event.target.value)))
                                                }
                                                value={aktuelleMessstelle.breitengrad}
                                            />
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="select-messstellen-schaltfeld"
                                            disabled={(!editEntry || aktuelleMessstelle.umspannwerk == "") ? true : false}
                                            value={schaltfeldSelectList.find(x => x.umspannwerk == aktuelleMessstelle.umspannwerk && x.name == aktuelleMessstelle.schaltfeld)}
                                            noOptionsText={<React.Fragment>
                                                {schaltfeldLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Schaltfelder"}</React.Fragment>}
                                            onChange={(_, newValue) => {
                                                if (newValue) dispatch(setSchaltfeld(newValue.name));
                                            }}
                                            inputValue={schaltfeldSelectInputValue}
                                            onInputChange={(_, newInputValue) => {
                                                setSchaltfeldSelectInputValue(newInputValue);
                                            }}
                                            options={schaltfeldSelectList.filter(x => x.umspannwerk == aktuelleMessstelle.umspannwerk)}
                                            getOptionLabel={(sf) => {
                                                if (sf) {
                                                    if (sf.nummer != "") return sf.name + " (" + sf.nummer + ")"
                                                    return sf.name
                                                }
                                                return ""
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    required={true}
                                                    {...params}
                                                    label="Feldname (Feldnummer)"
                                                    variant="outlined"
                                                />
                                            )}
                                            className={classes.selectEmpty}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="select-messstellen-spannungsebene"
                                            disabled={editEntry ? false : true}
                                            noOptionsText={<React.Fragment>
                                                {spannungsebeneLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Spannungsebene"}</React.Fragment>}
                                            value={aktuelleMessstelle.spannungsebene}
                                            onChange={(event, newValue) => {
                                                if (newValue) dispatch(setSpannungsebene(newValue));
                                            }}
                                            inputValue={spannungsebeneSelectInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setSpannungsebeneSelectInputValue(newInputValue);
                                            }}
                                            options={spannungsebeneSelectList}
                                            getOptionLabel={(option) => (option ? option : "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    required={true}
                                                    {...params}
                                                    label="Spannungsebene"
                                                    variant="outlined"
                                                />
                                            )}
                                            className={classes.selectEmpty}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="select-messstellen-stromwandler"
                                            noOptionsText={<React.Fragment>
                                                {stromwandlerLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Stromswandler"}</React.Fragment>}
                                            disabled={editEntry ? false : true}
                                            value={aktuelleMessstelle.stromwandler}
                                            onChange={(event, newValue) => {
                                                if (newValue) dispatch(setStromwandler(newValue));
                                            }}
                                            inputValue={stromwandlerSelectInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setStromwandlerSelectInputValue(newInputValue);
                                            }}
                                            options={stromwandlerSelectList.map((e) => e.faktor)}
                                            getOptionLabel={(option) => (option ? option : "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    required={true}
                                                    {...params}
                                                    label="Wandlerfaktor Strom"
                                                    variant="outlined"
                                                />
                                            )}
                                            className={classes.selectEmpty}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={3}>
                                        <Autocomplete
                                            id="select-messstellen-spannungswandler"
                                            noOptionsText={<React.Fragment>
                                                {spannungswandlerLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Spannungswandler"}</React.Fragment>}
                                            disabled={editEntry ? false : true}
                                            value={aktuelleMessstelle.spannungswandler}
                                            onChange={(event, newValue) => {
                                                if (newValue) dispatch(setSpannungswandler(newValue));
                                            }}
                                            inputValue={spannungswandlerSelectInputValue}
                                            onInputChange={(event, newInputValue) => {
                                                setSpannungswandlerSelectInputValue(newInputValue);
                                            }}
                                            options={spannungswandlerSelectList.map((e) => e.faktor)}
                                            getOptionLabel={(option) => (option ? option : "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    required={true}
                                                    {...params}
                                                    label="Wandlerfaktor Spannung"
                                                    variant="outlined"
                                                />
                                            )}
                                            className={classes.selectEmpty}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <FormControl className={classes.fullWidth}>
                                            <TextField
                                                id="messstelle-kommentar"
                                                label="Kommentar"
                                                disabled={editEntry ? false : true}
                                                variant="outlined"
                                                multiline
                                                rows={4}
                                                rowsMax={8}
                                                onChange={(event) =>
                                                    dispatch(setKommentar(event.target.value))
                                                }
                                                value={
                                                    aktuelleMessstelle.kommentar
                                                        ? aktuelleMessstelle.kommentar
                                                        : ""
                                                }
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </Paper>
                {printUWKoordinatenDialog()}
            </React.Fragment>
        );
    }
    return (<React.Fragment></React.Fragment>)
}
